import { render, staticRenderFns } from "./CellRendererPriority.vue?vue&type=template&id=53f77932"
import script from "./CellRendererPriority.vue?vue&type=script&lang=js"
export * from "./CellRendererPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports